// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Es3Y","index":"styles_index__2zIz9"};